<div class="bg-m0 flex select-none flex-col p-9">
  <div
    data-cy="createFileDialogTitle"
    class="text-s2 mt-5 flex-grow text-left text-2xl font-semibold"
    >Create File</div
  >

  <form
    class="flex w-[450px] flex-col"
    [formGroup]="createFileForm"
    (ngSubmit)="create()"
  >
    <div class="mt-9 text-base">Name</div>

    <input
      #fileName
      autocomplete="off"
      spellcheck="false"
      data-cy="createFileDialogFileNameInput"
      class="form-input border-s3 focus:border-m600 mt-2 h-[36px] rounded"
      [ngClass]="{
        'border-r600':
          createFileForm.controls['fileName'].invalid &&
          createFileForm.controls['fileName'].touched
      }"
      formControlName="fileName"
      placeholder="File Name"
    />
    <m-validation
      [control]="createFileForm.controls['fileName']"
    ></m-validation>

    <div class="mt-9">
      <button
        data-cy="createFileDialogCreateButton"
        class="bg-m600 text-m0 w-28 rounded py-3 text-base font-medium focus:outline-none"
        type="submit"
        >Create</button
      >

      <button
        data-cy="createFileDialogCancelButton"
        class="border-m600 text-m600 ml-3 w-28 rounded border py-3 text-base font-medium focus:outline-none"
        type="button"
        (click)="cancel()"
        >Cancel</button
      >
    </div>
  </form>
</div>
